/**
* @Author: zachalam
* @Date:   2017-02-06T13:53:09-08:00
* @Email:  zach@reflexmedia.com
* @Last modified by:   zachalam
* @Last modified time: 2017-02-06T13:53:09-08:00
*/



import * as sdk from '../sdk';
import { storeErrors } from './commonActions';
import { browserHistory } from 'react-router';
import { toast } from 'react-toastify';
import { storeMeta } from './metaActions';

export const clearTripLikes = (payload) => {
    return {
      type: 'CLEAR_TRIPLIKES'
    }
}

export const getTripLikes = (payload) => {
  return {
    type: 'STORE_TRIPLIKES',
    payload
  }
}

export const cancelTripFromStore = (payload) => {
  return {
    type: 'CANCEL_TRIP_FROM_STORE',
    payload
  }
}

export const joinTripDetail = () => {
  return {
    type: 'JOIN_TRIP_STORE'
  }
}

export const joinTripStore = (tripKey) => {
  return {
    type: 'JOIN_TRIP_EXTPROFILE',
    payload: tripKey
  }
}

export const favTripUserInStore = (favKey) => {
  // favorite a user who liked one of your trips.
  return {
    type: 'FAVORITE_TRIP_LIKED_USER',
    payload: favKey
  }
}

export const favTripInHome = (payload) => {
  return {
    type: 'STORE_TRIP_CHANGE_HOME',
    payload
  }
}

export const storeTripSearchTripJoin = (tripKey) => {
  return {
    type: 'TRIP_SEARCH_TRIP_JOIN',
    payload: tripKey
  }
}

export const storeTagList = (payload) => {
  return {
    type: 'STORE_TAG_LIST',
    payload
  }
}

export const storeTrip = (payload) => {
  return {
    type: 'STORE_TRIP',
    payload
  }
}

export const refreshTrip = (tripID) => {
  return(dispatch, getState) => {
    return sdk.getTrip(getState().auth.jwToken, tripID)
      .then( (response) => {
        console.log(response);
        if(response.data) {
          dispatch(storeTrip(response.data.data))
        }
      } )
      .catch( error => console.error(error))
  }
}

export const refreshTripLikes = (tripID,firstCall=true,per_page=0) => {
  // get the logged in users profile
  return (dispatch, getState) => {

    let pageToGet = 0;

    if(firstCall) { dispatch(clearTripLikes()); }
    else { pageToGet = getState().meta.triplikes_current_page+1;  }

    return sdk.getTripLikeList(getState().auth.jwToken,tripID,pageToGet)
              .then((response) => {
                dispatch(getTripLikes(response.data.data));
                // store pagination
                let page = response.data.meta.pagination;
                dispatch(storeMeta({triplikes_current_page: page.current_page, triplikes_total_pages: page.total_pages}));
              })
              .catch((error) => {
                //console.log("error");
              });

  }

}


export const createNewTrip = (formData) => {

  // calls sdk for new trip.
  return (dispatch, getState) => {
    return sdk.createNewTrip(getState().auth.jwToken,formData)
              .then((response)=> {
                // trip okay
                browserHistory.push("/trips");
                toast('Trip created successfully!', {type: toast.TYPE.INFO});


              })
              .catch((error) => {
                // trip not okay
                dispatch(storeErrors(error.response.data));
              })
  }

}


export const cancelTrip = (tripId,tripKey,reason) => {
  return (dispatch, getState) => {
    dispatch(cancelTripFromStore(tripKey));
    return sdk.cancelTrip(getState().auth.jwToken,tripId,reason)
              .then((response) => {
                // trip cancel okay
                browserHistory.push("/trips");
                toast('Trip canceled successfully!', {type: toast.TYPE.INFO});
              })
              .catch((error) => {
                // trip not okay
                toast('Could not cancel trip.', {type: toast.TYPE.INFO});
              })
              ;
  }
}

// ask to join users trip.
export const joinTrip = (tripId) => {
  return (dispatch, getState) => {
    return sdk.askToJoinTrip(getState().auth.jwToken,tripId);
  }
}

export const requestTags = () => {
  return (dispatch, getState) => {
    return sdk.getAllTags(getState().auth.jwToken)
      .then((response) => {
        dispatch(storeTagList(response.data.data))
      })
  }
}



// WEBPACK FOOTER //
// ./src/actions/tripActions.js